import React from 'react';

const StepIndicator = ({ steps = [], currentStep = 0 }) => {
  return (
    <div className="tw-flex tw-items-center tw-justify-center tw-w-full tw-py-8">
      {steps.map((step, index) => {
        const isCompleted = index < currentStep;
        const isActive = index === currentStep;
        const isLast = index === steps.length - 1;

        return (
          <React.Fragment key={index}>
            <div className="tw-flex tw-flex-col tw-items-center tw-gap-2">
              <div
                className={`tw-w-10 tw-h-10 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-sm tw-font-semibold tw-transition-all tw-duration-300 tw-border-2 ${
                  isCompleted
                    ? 'tw-bg-accent-500 tw-border-accent-500 tw-text-white'
                    : isActive
                      ? 'tw-bg-primary-500 tw-border-primary-500 tw-text-white tw-shadow-lg tw-shadow-primary-200'
                      : 'tw-bg-white tw-border-gray-300 tw-text-gray-400'
                }`}
              >
                {isCompleted ? (
                  <svg className="tw-w-5 tw-h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                ) : (
                  index + 1
                )}
              </div>
              <span
                className={`tw-text-xs tw-whitespace-nowrap tw-hidden sm:tw-block ${
                  isActive
                    ? 'tw-text-primary-600 tw-font-semibold'
                    : isCompleted
                      ? 'tw-text-accent-600 tw-font-medium'
                      : 'tw-text-gray-400'
                }`}
              >
                {step}
              </span>
            </div>
            {!isLast && (
              <div
                className={`tw-flex-1 tw-h-0.5 tw-mx-3 tw-transition-all tw-duration-300 ${
                  isCompleted ? 'tw-bg-accent-500' : 'tw-bg-gray-200'
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default StepIndicator;
